/**
 *  接口请求json对象
 */
import contextModel from './contextModel'

export default class RequestJson {
  constructor () {
    this.Context = contextModel
    this.SQLBuilderItem = []  //每次请求数据源脚本
  }

  /*
   * 添加SQLBuilderItem对象
   */
  add (_SQLBuilderItem) {
    this.SQLBuilderItem.push(_SQLBuilderItem)
  }
}


// WEBPACK FOOTER //
// ./src/wbap-core-commit/model/RequestJson.js